import { gsap } from 'gsap';
// import { ScrollTrigger } from "gsap/ScrollTrigger";

export const LegacyNav = (function () {
	'use strict';

	// gsap.registerPlugin(ScrollTrigger);

	var navToggle = document.querySelector('.menu-icon');
	var subMenuCollapse = document.querySelectorAll('.nav-primary-mobile li > a');
	var navMobile = document.querySelector('.nav-primary-mobile');
	var subMenuItemsMobile = document.querySelectorAll('.nav-primary-mobile .menu-item-has-children');
	var subMenuItems = document.querySelectorAll('.nav-primary .menu-item-has-children');
	var megaMenuParents = document.querySelectorAll('.menu-main .sub-menu > li');

	function init() {
		// Mobile Nav Toggle
		navToggle.addEventListener('click', function () {
			navToggle.classList.toggle('open');
			navMobile.classList.toggle('show');
			document.body.classList.toggle('nav-open');
		});

		// Mobile Submenu Toggle
		subMenuItemsMobile.forEach(function (item) {
			item.addEventListener('click', function () {
				var subMenu = this.querySelector('.sub-menu');
				var caretToggle = this.querySelector('a');

				if (!navMobile.classList.contains('sub-menu-open')) {
					subMenu.classList.add('show');
					caretToggle.classList.add('open');
					navMobile.classList.add('sub-menu-open');
				} else if (subMenu.classList.contains('show')) {
					subMenu.classList.remove('show');
					caretToggle.classList.remove('open');
					navMobile.classList.remove('sub-menu-open');
				}
			});
		});

		desktopSubMenu();
		megaMenuNav();
	}

	function desktopSubMenu() {
		for (var i = 0; i < subMenuItems.length; i++) {
			// setTimeout(function() {
				subMenuItems[i].addEventListener('mouseenter', function () {
					var subMenu = this.querySelector('.sub-menu');

					subMenu.classList.add('show');
					// TweenLite.to(subMenu, 0.3, { height: '210px' });
					gsap.to(subMenu, {
						duration: 0.3,
						height: 'auto',
						minHeight: '210px',
					})

				});

				subMenuItems[i].addEventListener('mouseleave', function () {
					var subMenu = this.querySelector('.sub-menu');

					subMenu.classList.remove('show');

					// TweenLite.to(subMenu, 0.3, { height: 0 });
					gsap.to(subMenu, {
						duration: 0.3,
						height: '0px',
						minHeight: '0px',
					})
				});
			// }, 500);
		}
	}

	function megaMenuNav() {
		var firstElements = document.querySelectorAll('.menu-main .sub-menu li:first-child .item-details');
		for (var i = 0; i < firstElements.length; i++) {
			firstElements[i].classList.add('first', 'show');
		}

		for (var j = 0; j < megaMenuParents.length; j++) {
			megaMenuParents[j].addEventListener('mouseenter', function () {
				this.parentElement.querySelector('.item-details.show').classList.remove('show');
				this.querySelector('.item-details').classList.add('show');

				if (!this.querySelector('.item-details').classList.contains('first')) {
					this.parentElement.querySelector('.item-details.first').classList.remove('show');
				}
			});
		}
	}

	return {
		init: init,
	};
})();
